/// <summary>
/// This object provides js functions for ... <br/>
/// <br/>
/// Author: MKU<br />
/// Date: 29.9.2023<br />
/// Copyright ©: EUDT GmbH 2022 <br />
/// Version-History:<br />
/// **********************************************************************<br />
/// *** v1.0.0 - 29.9.2023                                               *<br />
/// **********************************************************************<br />
/// * - basic functionality                                              *<br />
/// **********************************************************************<br />
/// *** v1.0.1 - 16.12.2024                                              *<br />
/// **********************************************************************<br />
/// * - add new checkbox for previous day                                *<br />
/// **********************************************************************<br />
/// </summary>


jQuery.widget("bluaul.ArchiveMeterReadings", jQuery.common.VisualBase, {
    vcV: new vcVisual(),
    myHtml: null,
    myStructure: {
        archive: {
            obj: null, menu: null,
            list: { header: null, entries: null },
            data: null, period: null
        },
    },

    _create: function () {
        var me = this;
        try {
            me.element.html("");
            // set the Visual-Name first
            me.options.invoke.vcvid = 355;
            me.options.invoke.vcgid = Math.floor(Math.random() * Math.floor(1000000));

            // inits the super class
            me._super();

        } catch (e) {
            me.writeError('_create', e);
            return false;
        }
        return true;
    },

    _initHTML: function () {
        var me = this;
        try {
            me.myHtml = me.element.find(".mr-archive");

            me._initTriggers();
            me._buildHtml();
            me.myStructure.archive.period = 1;

            me._updateArchList();

            me._setElementHeights();

            return true;
        } catch (e) {
            me.writeError('_initHTML', e);
            return false;
        }
        return true;
    },

    _initEvents: function () {
        var me = this;
        try {

            ////init event handlers
            me.myStructure.archive.menu.find("#div-period .button-toggle").button().off("click").on("click", function () {
                me._togglePeriod($(this));
                me._updateExportData();
            });

            // update table and export data, so that previous day is also shown and exported or not
            me.myStructure.archive.menu.find("#chbShowPreviousDay").change(function () {
                me._generateList($(this).is(":checked"));

                me._updateExportData();

            });

        } catch (e) {
            me.writeError('_initEvents', e);
            return false;
        }
        return true;
    },

    _initTriggers: function () {
        var me = this;
        try {

            me.element.on("mr-update-archive-header", function (e) {
                var colDate = me.fnd(".arch.col0");
                var colDiff = me.fnd(".arch.col4");
                var chbLabel = me.fnd("#chbShowLastLabel");
                colDate.html("");
                colDiff.html("");
                chbLabel.html("");

                if (me.myStructure.archive.period == 1) {
                    colDate.html(me.specific.resources.day);
                    colDiff.html(me.specific.resources.dailyUsage);
                    chbLabel.html(me.specific.resources.showLastDay);
                }
                else {
                    colDate.html(me.specific.resources.month);
                    colDiff.html(me.specific.resources.monthlyUsage);
                    chbLabel.html(me.specific.resources.showLastMonth);
                }
            });

        } catch (e) { me.writeError('_initTriggers', e); return false; }
        return true;
    },
    _setElementHeights: function () {
        /// <summary>
        /// This function calculates and sets the height of elements relatively to the general content height
        /// </summary>
        var me = this;
        try {
            //calculate and set height of list
            var parentHeight = me.fnd("#div-archive").height();
            var menuHeight = me.fnd("#div-archive-menu").height();
            var menuMarginBottom = parseInt($("#div-archive-menu").css("marginBottom"));
            var headerHeight = me.fnd("#div-archive-header").height();
            var listHeight = parentHeight - menuHeight - headerHeight - menuMarginBottom;
            me.fnd(".lst-entries").css("height", listHeight);

        } catch (e) { me._writeErr(e); }
    },

    _buildHtml: function () {
        var me = this;
        try {
            let obj = null;

            me.myStructure.archive = $("<div>").attr("id", "div-archive");
            obj = me.myStructure.archive;

            obj.menu = $("<div>").attr("id", "div-archive-menu").addClass("vc-grid-margin-bottom");
            obj.list = $("<div>").attr("id", "div-archive-list").addClass("vc-list");
            obj.header = $("<div>").attr("id", "div-archive-header").addClass("vc-list-header color-bg-secondary");
            obj.list.append(obj.header);

            var divPeriodMenu = $("<div>").attr("id", "div-period").addClass("vc-grid-margin-right float").css("display", "flex").css("align-items", "center");
            var divBtnDay = $("<div>").attr("id", "div-btn-day").addClass("button-toggle button-toggle-active").html(me.specific.resources.daily);
            var divBtnMonth = $("<div>").attr("id", "div-btn-month").addClass("button-toggle").html(me.specific.resources.monthly);

            var divCheckbox = $("<div>").addClass("vc-grid-2col").css("margin-left", "10px");
            var checkbox = $("<input>").attr("id", "chbShowPreviousDay").attr("type", "checkbox");
            var label = $("<label>").attr("id", "chbShowLastLabel").attr("for", "chbShowPreviousDay").html(me.specific.resources.showLastDay).css("margin-left", "5px");
            divCheckbox.append(checkbox).append(label);

            divPeriodMenu.append(divBtnDay, divBtnMonth, divCheckbox);

            obj = me.myStructure.archive;
            obj.menu.append(divPeriodMenu);
            obj.menu.append($("<div>").attr("style", "clear:both"));

            // list with data
            var l1 = $("<div>").addClass("vc-list-item");
            var c1 = $("<div>").addClass("vc-list-col");
            l1.append(c1);
            c1.append($("<div>").addClass("vc-list-col-element arch col0").html(me.specific.resources.day));
            c1.append($("<div>").addClass("vc-list-col-element arch col1").html(me.specific.resources.signal));
            c1.append($("<div>").addClass("vc-list-col-element arch col2 txtright").html(me.specific.resources.meterReading));
            c1.append($("<div>").addClass("vc-list-col-element arch col3 txtright").html("<br>")); // dimension for meterreading
            c1.append($("<div>").addClass("vc-list-col-element arch col4 txtright").html(me.specific.resources.dailyUsage));
            c1.append($("<div>").addClass("vc-list-col-element arch col5 txtright").html("<br>")); // dimension for usage
            obj.header.append(l1);

            obj.data = $("<div>").addClass("lst-entries vc-list-table");
            obj.list.append(obj.data);

            obj.append(obj.menu, obj.list);

            me.myHtml.append(me.myStructure.archive);

        } catch (e) {
            me.writeError('_buildHtml', e);
            return false;
        }
        return true;
    },

    _togglePeriod: function (obj) {
        /// <summary>
        /// This function switches between daily and monthly basis and updates the list according to the selected period
        /// </summary>
        var me = this;
        try {

            me.myStructure.archive.menu.find("#div-period .button-toggle").removeClass("button-toggle-active");
            obj.addClass("button-toggle-active");

            switch (obj.attr("id")) {

                case "div-btn-day":
                    me.myStructure.archive.period = 1;
                    me._updateArchList();
                    break;

                case "div-btn-month":
                    me.myStructure.archive.period = 2;
                    me._updateArchList();
                    break;

                default:
                    break;
            }

        } catch (e) {
            me.writeError('_togglePeriod', e);
            return false;
        }
        return true;
    },

    _updateArchList: function () {
        /// <summary>
        /// This function gets the data from the db and updates the list in the chart
        /// </summary>
        var me = this;
        try {
            me._initList(true);

            var param = {};
            param.period = me.myStructure.archive.period;

            // update the archive header labelling depending on the selection of monthly or daily basis
            me.element.trigger({ type: "mr-update-archive-header" });

            // get data from db
            me.getData(param, function (result) {
                if (result == null) {
                    me.showMessage(me.resources.err_loadData, true);
                    return true;
                }
                
                me.myStructure.archive.data = result;
                me._generateList(me.myStructure.archive.menu.find("#chbShowPreviousDay").is(":checked"));

                return true;
            });
        } catch (e) {
            me.writeError('_updateArchList', e);
            return false;
        }
    },

    _generateList: function (prevDay) {
        /// <summary>
        /// This function generates a list from the data
        /// </summary>
        var me = this;

        try {

            var list = me._initList(false);

            let obj = me.myStructure.archive.data;

            if (obj === null) {
                list.html($("<br>"));
                list.append($("<div>").addClass("note").html(me.resources.noEntriesExist));
                return false;
            }

            if (obj.rows === null) {
                list.html($("<br>"));
                list.append($("<div>").addClass("note").html(me.resources.noEntriesExist));
                return false;
            }

            var startPos = 1;
            if (obj.rows.length < 2 || prevDay) // if prevDay, day before selected day shall be also listed
                startPos = 0; 

            // fill corresponding list with items
            // start with second row, because first row only contains day/month before actual selection for calculation of the daily/monthly usage
            for (var i = startPos; i < obj.rows.length; i++) {
                list.append(me._fillItems(i));
            }

            me._formatTable();

            return true;
        } catch (e) { me.writeError('_generateList', e); return false; }
    },

    _fillItems: function (i) {
        /// <summary>
        /// This function fills the list with all corresponding items
        /// </summary>
        var me = this;
        try {
            let obj = null;
            var item = $("<div>", { "class": "vc-list-item" });

            obj = me.myStructure.archive.data;
            item.append($("<div>", { "class": "vc-list-col col0" }).html($("<div>", { "class": "vc-list-col-element", "html": me._getDateVals(i) })));
            item.append($("<div>", { "class": "vc-list-col col1" }).html($("<div>", { "class": "vc-list-col-element", "html": obj.rows[i].name + " [" + obj.rows[i].dims + "]" })));
            item.append($("<div>", { "class": "vc-list-col col2" }).html($("<div>", { "class": "vc-list-col-element value", "html": me._checkEntry(obj.rows[i].zst) })));
            item.append($("<div>", { "class": "vc-list-col col3" }).html($("<div>", { "class": "vc-list-col-element txtLeft", "html": obj.rows[i].dims })));
            item.append($("<div>", { "class": "vc-list-col col4" }).html($("<div>", { "class": "vc-list-col-element " + me._checkIfValueOrNot(i), "html": me._calculateDiff(i) })));
            item.append($("<div>", { "class": "vc-list-col col5" }).html($("<div>", { "class": "vc-list-col-element txtLeft", "html": obj.rows[i].dims })));

            return item;

        } catch (e) { me.writeError('_fillItems', e); return false; }
    },

    _checkIfValueOrNot: function (i) {
        /// <summary>
        /// This function checks if entry will be value or placeholder
        /// </summary>
        var me = this;
        try {
            var addClass = "value";
            if (i == 0)
                addClass = "placeholder";

            return addClass;

        } catch (e) { me.writeError('_checkIfValueOrNot', e); return false; }
    },

    _initList: function (showIcon) {
        /// <summary>
        /// This function initializes the list
        /// </summary>
        var me = this;
        try {

            var list = me.fnd(".lst-entries");

            if (showIcon)
                return list.html(me.getLoadingIcon()); // show loading icon
            else
                return list.html("");

        } catch (e) { me.writeError('_initList', e); return false; }
    },

    _checkEntry: function (str) {
        /// <summary>
        /// This function checks if a string is empty - adds placeholder for empty strings
        /// </summary>
        var me = this;
        try {
            if (str == "" || str == null)
                return "-";
            else
                return str;

        } catch (e) { me.writeError('_checkEntry', e); return false; }
    },

    _getDateVals: function (i) {
        /// <summary>
        /// This function checks the selected period and changes the date format
        /// </summary>
        var me = this;
        try {
            // updates the shown date format depending on monthly or daily basis
            if (me.myStructure.archive.period == 1)
                return $.datepicker.formatDate('dd.mm.yy', me.myStructure.archive.data.rows[i].day);
            else
                return $.datepicker.formatDate('MM yy', me.myStructure.archive.data.rows[i].month);

        } catch (e) { me.writeError('_getDateList', e); return false; }
    },
    _updateExportData: function () {
        /// <summary>
        /// This function updates the cs export data for correct xls export
        /// </summary>
        var me = this;
        try {
            var param = {}
            param.prevDay = me.myStructure.archive.menu.find("#chbShowPreviousDay").is(":checked");

            // send data
            me.updateData(param, function (result) { });

        } catch (e) { me.writeError('_updateExportData', e); return false; }
    },

    _formatTable: function () {
        var me = this;
        try {

            me.fnd('.lst-entries .vc-list-item:even').addClass('alt');
            me.fnd('.lst-entries .vc-list-item .vc-list-col-element.value').formatDouble(2);

            me.fnd(".placeholder").css("float", "right");

        } catch (e) { me.writeError('_formatTable', e); return false; }
    },

    _calculateDiff: function (i) {
        /// <summary>
        /// This function calculates the difference for the consumption
        /// </summary>
        var me = this;
        try {

            if (i == 0)
                return "-";
            else
                return me.myStructure.archive.data.rows[i].zst - me.myStructure.archive.data.rows[i - 1].zst;

        } catch (e) { me.writeError('_calculateDiff', e); return false; }
    },

    specificInfoHandling: function (bError) {
        var me = this;
        try {
            if (bError) {
                me.fnd("#div-archive").hide();
            }
            return true;
        } catch (e) {
            me.writeError('specificInfoHandling', e); return false;
        }
    }
});